module.exports = __webpack_public_path__ + "img/goods3_4.752b7f04.jpg";